<div class="w-full min-h-[3rem] relative">
	<div class="absolute inset-px z-10 bg-neutral-950 mix-blend-multiply flex items-center justify-center font-decimaRegular text-white text-sm leading-none">
		{{ data.message }}
	</div>
	<div class="absolute inset-0 z-0 backdrop-brightness-[8] backdrop-blur">

	</div>
</div>